import cx from 'classnames';

import { NotificationVariant } from 'modules/Notifications/NotificationsProvider/utils';
import { IconType } from 'utils/types';

const variants = {
  primary: 'bg-primaryComp-50',
  alert: 'bg-tertiary-50',
};

interface NotificationIconProps {
  icon: IconType;
  variant?: NotificationVariant;
  isRead: boolean;
}

const NotificationIcon = ({ icon: Icon, variant = 'primary', isRead }: NotificationIconProps) => (
  <div className={cx('rounded-xl h-fit w-fit p-1.5 relative', variants[variant])}>
    <Icon className="h-5 w-5 stroke-white stroke-1.5" />
    {!isRead && <div className="absolute -top-1 -right-1 w-1.5 h-1.5 bg-tertiary-50 rounded-full" />}
  </div>
);

export default NotificationIcon;
